import Logo from '@scramble/design-system/logo/scramble_logo_white.svg';
import { Navigation } from '../../navigation';
import { UserMenu } from '../../user';
import type { DesktopNavigationProps } from '../../types';
import IconHome from '@scramble/design-system/icons/home-line.svg?react';
import s from './index.module.scss';

export const DesktopNavigation = ({
  productName,
  menu = [],
  user,
  dropdownMenu,
  onHomeClick
}: DesktopNavigationProps): JSX.Element => {
  return (
    <div className={s.wrapper}>
      <div className={s.content}>
        <div className={s.header}>
          <div className={s.logo}>
            <img src={Logo} alt="logo" width={112} height={20} />
            {productName && <span className="f-body-sm f-500">{productName}</span>}
          </div>
          {onHomeClick && <button className={s.home} onClick={onHomeClick}>
            <IconHome />
          </button>}
        </div>
        <div className={s.navigation}>
          <Navigation menu={menu} />
        </div>
        <UserMenu user={user} dropdownMenu={dropdownMenu} />
      </div>
    </div>
  );
};
